import React from 'react';

import InformationIcon from '@atlaskit/icon/core/information-circle';

export const DetailsPanelHeaderIcon = () => {
	return <InformationIcon label="" />;
};
